import * as React from 'react'
import './news-letter.css'

export default class NewsLetter extends React.Component<any> {
  constructor(props: any) {
    super(props)
    this.state = {}
  }

  render() {
    return (
      <>
        <h2>Finndu okkur</h2>
        <span className="social-icons">
          <a
            href="https://www.facebook.com/ebson.reykjavik/?ref=br_rs"
            className="facebook-social"
          >
            <img src="/images/Facebook.svg" />
          </a>
          <a href="https://www.instagram.com/ebson.reykjavik/?hl=en">
            <img src="/images/Instagram.svg" />
          </a>
        </span>
      </>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Shared/news-letter/news-letter.tsx